/** The portal's sentence for a request that got no answer at all — the one case it is true of. */
export const UNREACHED = "Couldn't reach the Brush API.";

/** An error carrying an HTTP status: the API answered, whatever it said. `ApiError` and its subclasses are. */
function answered(error: unknown): boolean {
  return typeof error === 'object' && error !== null && typeof (error as { status?: unknown }).status === 'number';
}

/**
 * What the portal's error card says (#230).
 *
 * It said "Couldn't reach the Brush API." for any failure of its first reads, so an answered 401, 404 or 405 sent a
 * reader to check their network. A request the API answered is described by its answer — `describe` is
 * `describeApiError`, passed in so this module imports nothing and runs under `node --test` — and only one that got
 * no answer says the API could not be reached.
 */
export function portalFailureMessage(error: unknown, describe: (error: unknown) => string | null): string {
  if (!answered(error)) return UNREACHED;
  return describe(error) ?? UNREACHED;
}
